
import ModuleBase, { moduleInit, ViewLayer, implementFunction } from "../../../../framework/core/mvvm/module_base";
import ModuleManager from "../../../../framework/core/module_manager";
import EventManager from "../../../../manager/event_manager";
import Utility from "../../../../utility/utility";
import TimeManager from "../../../../manager/time_manager";
import * as ProtoPokerRoom from "../../net/proto/proto_poker_room";
import NetMsgDataBase from "../../net/net_msg_data_table_base";
import ModelBase from "../../../../framework/core/mvvm/model_base";
import ChatInfoView from "./chatinfo_view";
import GameServer from "../../../hall/server/gameserver/game_server";
import ModelData, { IUserData } from "../../../public/model_data";
import UserDataManager, { IUserCurrencyData } from "../../../../manager/user_manager";
import AppData from "../../../public/const/app_data";
import PlayerIconModule from "../../../hall/module/playericon/playerIcon";
const { ccclass, property } = cc._decorator;
enum ChatMsgType {
    voiceMsg = 0,
    shotMsg = 1,
    emojiMsg = 2,
    text = 3,
    iconMsg=4,
    gift = 10,
    tmpLeave = 99,
}

@ccclass
@moduleInit("ChatInfo")
export default class ChatInfo extends PlayerIconModule{

    _model: ModelBase = new ModelBase()
    _lastPinTime: number = 0
    protected LastSendChatTime: number = 0

     posX=0
     posY=0
     emojiId=0
     clickPlayerId=0
     moduleName:string=""
     isCanClick:boolean = true;//表情点击

    onInit() {
        super.onInit();
        this._model.init(GameServer.instance.netClient)
        this.addEvent();
    }

    onShow(arg0) {
        super.onShow(null);
        this.clickPlayerId= ModelData.instance.roleData.id;
        this.moduleName=AppData.gameNameToTableModule[AppData.gameName]
    }

    onDeferShow(arg0){
        super.onDeferShow(null);
    }


    addEvent() {
        this.eventBind("seatViewClick", this.sendChat)

        this.view.myExpListView.on('scroll-ended',this.scrollEnd,this)
        this.view.myExpListView.on('scroll-began',this.scorllBegin,this)

        let childs = this.view.getMagics();
        for(let i=0;i<childs.length;i++)
        {
            childs[i].on('click', this.onClick_Emoji, this);
        }
        
    }
    protected onClick_Emoji(event: cc.Button): boolean {

        if (!this.isCanClick) {
            return;
        }

        let isClickValid = Utility.btnClickValid(100)
        if (!isClickValid) {
            return isClickValid
        }
        
        Utility.playButtonSound()
        let node: cc.Node = event.node
        let str:string=''
        str+=ModelData.instance.roleData.id+'_'
        str+=this.clickPlayerId.toString()+'_'
        str+=node.name
        
        this.sendChat(str)
        ModuleManager.instance.hideModule("PlayerInfoSetting")
        
    }

    protected scorllBegin(){
        this.isCanClick = false;
    }

    protected scrollEnd(){
        this.isCanClick = true;
    }


    sendChat(content) {
        let AppRunningTime = TimeManager.instance.AppRunningTime
        if (this.LastSendChatTime > 0 && this.LastSendChatTime + 2.6 > AppRunningTime) {
            return
        }
       
        this.LastSendChatTime = AppRunningTime
        let chatMsgType = ChatMsgType.shotMsg
        this.send_chat_request(chatMsgType, content)
    }
    send_chat_request(chatMsgType: number, text: string){
        let chatmsg: ProtoPokerRoom.Room.IChatMsg = {
            msgType: chatMsgType,
            text: text
        }
        let protoData: ProtoPokerRoom.Room.IChatMsgReq = {
            chatMsg: chatmsg
        }
        this._model.sendMsg(NetMsgDataBase.Chat, protoData)
        //EventManager.instance.dispatch("show_emoji_msg",this.moduleName,protoData,false)
    }

   
}